import { useState, type FormEvent } from 'react';
import { appeals, type ModerationRecord } from '../net/api';
import { RecordView } from './Record';

/** For players who can't sign in because of a ban: confirm the account, then appeal. */
export function BannedAppeal({ login: initialLogin, onBack }: { login: string; onBack: () => void }) {
  const [login, setLogin] = useState(initialLogin);
  const [password, setPassword] = useState('');
  const [record, setRecord] = useState<ModerationRecord>();
  const [error, setError] = useState<string>();

  async function lookup(e: FormEvent) {
    e.preventDefault();
    try {
      setRecord(await appeals.lookup(login, password));
      setError(undefined);
    } catch (err) {
      setError((err as Error).message);
    }
  }

  return (
    <section className="panel narrow">
      <h2>Appeal a ban</h2>
      {!record ? (
        <form onSubmit={lookup}>
          <p className="muted small-print">Enter your details so we know it's your account.</p>
          <div className="field"><label htmlFor="ap-login">Username or email</label><input id="ap-login" value={login} onChange={(e) => setLogin(e.target.value)} required /></div>
          <div className="field"><label htmlFor="ap-pass">Password</label><input id="ap-pass" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required /></div>
          {error && <p className="form-error" role="alert">{error}</p>}
          <button className="btn wide">Continue</button>
        </form>
      ) : (
        <RecordView
          record={record}
          onAppeal={async (t, id, reason) => {
            await appeals.fileSignedOut(login, password, t, id, reason);
            setRecord(await appeals.lookup(login, password));
          }}
        />
      )}
      <button className="btn ghost" onClick={onBack}>Back to sign in</button>
    </section>
  );
}
